import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { MessageService } from 'primeng/api';
import { BlockUIModule } from 'primeng/blockui';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { ScrollTopModule } from 'primeng/scrolltop';
import { ToastModule } from 'primeng/toast';
import { WidgetComponent } from './widget.component';

const PRIMENG_MODULES = [
  ToastModule,
  BlockUIModule,
  ProgressSpinnerModule,
  ScrollTopModule
];

@NgModule({
  declarations: [WidgetComponent],
  imports: [
    CommonModule,
    TranslateModule,
    ...PRIMENG_MODULES
  ],
  exports: [
    WidgetComponent
  ],
  providers: [MessageService],
})
export class WidgetModule {
  constructor() {
  }
}
